import { render, staticRenderFns } from "./board-header-setting.vue?vue&type=template&id=17e1a714&"
import script from "./board-header-setting.vue?vue&type=script&lang=js&"
export * from "./board-header-setting.vue?vue&type=script&lang=js&"
import style0 from "./board-header-setting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports